var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',[_vm._v(_vm._s(_vm.$t("titles.report")))]),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":require("./../assets/pictures/report.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e527513e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Report.vue
// module id = 446
// module chunks = 0